import { ModelBase } from "@models/UpsertableBase";
import { DataType } from "@dndModels/Types";

/**
 * Something that makes an encounter more complicated: Slippery, Crumbling Ground, Monsters from Below, etc.
 * The name and description are all there is to it, the description says how it works.
 */
export class EncounterComplication extends ModelBase {
  data_type: DataType = "encounter_complication";
  environment_ids: string[] = []; // The Environments this is suggested for.  Empty means it's suggested for any Environment.

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.environment_ids = obj.environment_ids ? [...obj.environment_ids] : [];
    }
  }

  suggestedFor(environment_ids: string[]): boolean {
    return this.environment_ids.length === 0 || this.environment_ids.some(o => environment_ids.includes(o));
  }

  toDBObj(): any {
    const base_db_obj = super.toDBObj();
    return {
      ...base_db_obj,
      environment_ids: this.environment_ids,
    };
  }

  toLight(): any {
    const base_db_obj = super.toLight();
    return {
      ...base_db_obj,
      environment_ids: this.environment_ids,
    };
  }

  copy(copyMe: EncounterComplication, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.environment_ids = [...copyMe.environment_ids];
  }

  clone(drop_ids = false): EncounterComplication {
    const new_obj = new EncounterComplication();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}
